import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import routes from '../routers'
import { rememberReturnPath } from '../utils/returnTo'
import LoadingSpinner from './LoadingSpinner'

// A signed-in page opened while signed out: sign in, then carry on to that page
const RedirectPage = () => {
  const navigation = useNavigate()
  const { pathname, search } = useLocation()

  useEffect(() => {
    rememberReturnPath(`${pathname}${search}`)
    navigation(routes.signIn)
  }, [])

  return <LoadingSpinner />
}

export default RedirectPage
